(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcf-devis"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pcf-quote-section')) {
  customElements.define('pcf-quote-section', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      const fields = this.querySelector('[data-quote-fields]');
      if (!fields) return;
      const form = fields.closest('form');
      const quantities = [...fields.querySelectorAll('[data-quote-quantity]')];
      const reception = fields.querySelector('[data-quote-reception]');
      const address = fields.querySelector('[data-quote-address]');
      const submit = fields.querySelector('[data-quote-submit]');
      const totalText = fields.querySelector('[data-quote-total]');
      const update = () => {
        let total = 0;
        let valid = quantities.length > 0;
        quantities.forEach(input => {
          const number = input.valueAsNumber;
          const legal = Number.isSafeInteger(number) && number >= 0;
          input.setCustomValidity(legal ? '' : fields.dataset.invalid);
          if (legal) total += number;
          else valid = false;
        });
        valid = valid && Number.isSafeInteger(total);
        if (valid && total === 0) quantities[0].setCustomValidity(fields.dataset.empty);
        totalText.textContent = fields.dataset.totalTemplate.replace('__COUNT__', String(total));
        const shipping = reception.selectedOptions[0]?.dataset.mode === 'shipping';
        fields.querySelector('[data-quote-address-wrap]').hidden = !shipping;
        address.disabled = !shipping;
        address.required = shipping;
        fields.querySelector('[data-quote-shipping-note]').hidden = !shipping;
        fields.querySelector('[data-quote-pickup-note]').hidden = shipping;
        submit.disabled = !valid || total === 0;
        return valid && total > 0;
      };
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      fields.querySelectorAll('[data-quote-step]').forEach(button => {
        button.addEventListener('click', () => {
          const input = button.parentElement.querySelector('input');
          const current = Number.isSafeInteger(input.valueAsNumber) ? input.valueAsNumber : 0;
          const next = Math.max(0, current + Number(button.dataset.quoteStep));
          if (Number.isSafeInteger(next)) input.value = String(next);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
      form.addEventListener('submit', event => {
        if (!update() || !form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        if (this.dataset.channel === 'contact') return;
        event.preventDefault();
        const details = [...fields.querySelectorAll('[data-quote-detail]')].filter(input => input.value.trim()).map(input => input.name.slice(8, -1) + ' : ' + input.value.trim());
        const selection = quantities.filter(input => input.valueAsNumber > 0).map(input => input.dataset.label + ' : ' + input.value);
        const message = [fields.dataset.intro, ...details, ...selection, totalText.textContent, reception.name.slice(8, -1) + ' : ' + reception.value];
        if (!address.disabled) message.push(address.name.slice(8, -1) + ' : ' + address.value.trim(), fields.querySelector('[data-quote-shipping-note]').textContent);
        message.push(fields.dataset.end);
        window.open('https://wa.me/33749494924?text=' + encodeURIComponent(message.join('\n')), '_blank', 'noopener,noreferrer');
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcf-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pcf-home-section')) {
  customElements.define('pcf-home-section', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.querySelectorAll('[data-pcf-card]').forEach(card => {
        card.querySelectorAll('[data-pcf-pack]').forEach(button => {
          button.addEventListener('click', () => {
            card.querySelectorAll('[data-pcf-pack]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
            card.querySelector('[data-pcf-price]').textContent = button.dataset.price;
            const old = card.querySelector('[data-pcf-old-price]');
            old.textContent = button.dataset.oldPrice;
            old.hidden = !button.dataset.oldPrice;
            const unit = card.querySelector('[data-pcf-unit]');
            unit.textContent = unit.dataset.unitTemplate.replace('__PRICE__', button.dataset.unitPrice);
            unit.hidden = button.dataset.quantity === '1';
            const link = card.querySelector('[data-pcf-product-link]');
            link.href = button.dataset.href;
            link.textContent = button.dataset.available === 'true' ? link.dataset.readyLabel : link.dataset.soldLabel;
          });
        });
      });
      const form = this.querySelector('[data-pcf-mix]');
      if (!form) return;
      const inputs = [...form.querySelectorAll('[data-pcf-flavour]')];
      const counter = form.querySelector('[data-pcf-count]');
      const submit = form.querySelector('[data-pcf-submit]');
      const progress = form.querySelector('[data-pcf-progress]');
      const update = () => {
        let total = 0;
        let valid = true;
        inputs.forEach(input => {
          if (input.disabled) return;
          const value = input.valueAsNumber;
          const legal = Number.isInteger(value) && value >= 0 && value <= 24;
          input.setCustomValidity(legal ? '' : form.dataset.invalid);
          if (!legal) valid = false;
          else total += value;
        });
        counter.textContent = form.dataset.countTemplate.replace('__COUNT__', String(total));
        if (total > 24) counter.textContent += ' — ' + form.dataset.removeTemplate.replace('__COUNT__', String(total - 24));
        progress.value = Math.min(24, total);
        if (submit) submit.disabled = !valid || total !== 24 || form.dataset.available !== 'true';
        return valid && total === 24;
      };
      inputs.forEach(input => input.addEventListener('input', update));
      form.querySelectorAll('[data-pcf-step]').forEach(button => {
        button.addEventListener('click', () => {
          const input = button.parentElement.querySelector('input');
          if (input.disabled) return;
          const current = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : 0;
          input.value = Math.min(24, Math.max(0, current + Number(button.dataset.pcfStep)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
      form.addEventListener('submit', event => {
        if (!update() || form.dataset.available !== 'true') {
          event.preventDefault();
          form.reportValidity();
          counter.focus();
        }
      });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcf-product-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pcf-product-purchase')) {
  customElements.define('pcf-product-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('product-info[data-pcf-experience]');
      if (!this.root) return;
      this.trigger = this.querySelector('[data-pcf-sticky-submit]');
      this.sync = () => {
        const summary = this.root.querySelector('[data-pcf-purchase-summary]');
        const buy = this.root.querySelector('product-form button[name="add"]');
        if (!buy || !summary) { this.hidden = true; return; }
        this.querySelector('[data-pcf-sticky-price]').textContent = summary.dataset.price;
        this.querySelector('[data-pcf-sticky-format]').textContent = summary.dataset.format;
        this.trigger.disabled = buy.disabled || buy.getAttribute('aria-disabled') === 'true';
        this.trigger.setAttribute('aria-busy', String(buy.classList.contains('loading')));
        this.trigger.textContent = buy.querySelector('span')?.textContent.trim() || buy.textContent.trim();
        const box = buy.getBoundingClientRect();
        this.hidden = box.top >= 0 && box.bottom <= window.innerHeight;
      };
      this.onClick = () => {
        const buy = this.root.querySelector('product-form button[name="add"]');
        const quantity = this.root.querySelector('input[name="quantity"]');
        if (quantity && !quantity.reportValidity()) { quantity.focus(); return; }
        if (buy && !buy.disabled && buy.getAttribute('aria-disabled') !== 'true') buy.click();
      };
      this.trigger.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, characterData: true });
      window.addEventListener('scroll', this.sync, { passive: true });
      window.addEventListener('resize', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.trigger?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.sync);
      window.removeEventListener('resize', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
